export default __webpack_public_path__ + "static/media/1972.fa8699da.png";